import React from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import PrimaryPinkButton from './primary-pink-button'
import './header.css'

const Header = (props) => {
  return (
    <div data-role="Header" className="header-header">
      <nav className="header-nav">
        <div className="header-container">
          <img
            alt={props.image_alt3}
            src={props.image_src3}
            className="header-image"
          />
          <div className="header-menu">
            <Link to="/" className="header-link Large">
              Home
            </Link>
            <a href="https://blog.gracereminder.com" className="header-link1">
              Blog
            </a>
            <a href="https://shop.gracereminder.com" className="header-link2">
              Shop
            </a>
          </div>
          <div className="header-container1">
            <div className="header-container2">
              <PrimaryPinkButton button="buy now"></PrimaryPinkButton>
            </div>
            <div data-role="BurgerMenu" className="header-burger-menu">
              <svg viewBox="0 0 1024 1024" className="header-icon">
                <path d="M128 256h768v86h-768v-86zM128 554v-84h768v84h-768zM128 768v-86h768v86h-768z"></path>
              </svg>
            </div>
          </div>
        </div>
      </nav>
      <div data-role="MobileMenu" className="header-mobile-menu">
        <div className="header-top">
          <Link to="/" className="header-link3 Large">
            Soft UI Design System
          </Link>
          <div data-role="CloseMobileMenu" className="header-close-menu">
            <svg viewBox="0 0 1024 1024" className="header-icon2">
              <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
            </svg>
          </div>
        </div>
        <div className="header-mid">
          <div className="header-menu1">
            <a href="/" className="header-home">
              Home
            </a>
            <span className="header-blog Large">Blog</span>
            <span className="header-shop Large">Shop</span>
          </div>
        </div>
        <div className="header-bot">
          <PrimaryPinkButton button="buy now"></PrimaryPinkButton>
        </div>
      </div>
    </div>
  )
}

Header.defaultProps = {
  image_alt2: 'image',
  image_src2: 'https://play.teleporthq.io/static/svg/placeholders/no-image.svg',
  image_alt: 'image',
  image_src1: 'https://play.teleporthq.io/static/svg/default-img.svg',
  image_src: 'https://play.teleporthq.io/static/svg/default-img.svg',
  image_src3: '/logo-grace-reminder-web.svg',
  image_alt3: 'image',
  image_alt1: 'image',
}

Header.propTypes = {
  image_alt2: PropTypes.string,
  image_src2: PropTypes.string,
  image_alt: PropTypes.string,
  image_src1: PropTypes.string,
  image_src: PropTypes.string,
  image_src3: PropTypes.string,
  image_alt3: PropTypes.string,
  image_alt1: PropTypes.string,
}

export default Header
